export default {
  title: "404",
  subtitle: "不明なページ",
  message: "The page you are looking for may have had its URL changed or has already been deleted. <br> If this page has been bookmarked, please change the bookmark destination to another page.",
  return_top: "Return to TOP",
};